<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle"           
          >
          
          <template v-slot:body>
            <v-layout column overflow-auto>
              <v-row>
							<v-col cols="12" class="pa-0">
								<i-card-top
									class="d-md-flex"
									outlined

                  :useBtnList="[
                      'btnRetrieve', //Retrieve
                      'btnExcel'   //Save Excel
                    ]"
                    @btnRetrieve="btnRetrieve()"
                    @btnExcel="btnExcel()"
                    
								>
									<template v-slot:body>
										<v-row no-gutters class="center pa-0 pl-1">
											<v-col cols="12">
												<v-row dense class="ma-0">	
													<v-icon small color="blue" class="pb-0">mdi-circle</v-icon>
													<span class="pa-2 pr-0">Ship No : </span>
													<v-col cols="1">
														<v-select
                            v-model="selectShipNo"
                            :items="shipNoList"
                            return-object                           
                            item-value="selectShipNo"
                            single-line
                            outlined
                            dense
                            height="32"
                            @change="changeShipNo" />
													</v-col>
                          <v-icon small color="blue" class="pb-0">mdi-circle</v-icon>
													<span class="pa-2 pr-0">POR No : </span>
													<v-col cols="1" class="pl-0">
														<v-select
                              v-model="selectPorNo"
															:items="porList"														
                              item-value="selectPorNo"
															return-object
															single-line
															outlined
															dense
                              :label="'All'" @change="btnRetrieve()"
                              />
													</v-col>													
													<v-icon small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
													<span class="pa-2 pr-0">Stage : </span>
													<v-col cols="1" >
														<v-select
															v-model="stage.select"
															:items="stage.items"
                              item-text="name"                              
															item-value="cd"
															return-object
															single-line
															outlined
															dense
														></v-select>
													</v-col>
													<v-icon small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
													<span class="pa-2 pr-0">Warehouse : </span>
													<v-col cols="1" >
														<v-select
															v-model="whDiv.select"
															:items="whDiv.items"                              
                              item-text="name"                              
															item-value="cd"
															return-object
															single-line
															outlined
															dense														
														></v-select>
													</v-col>  
												</v-row>
												<v-row dense class="ma-0">	
													<v-icon small color="blue" class="pb-0">mdi-circle</v-icon>
													<span class="pa-2 pr-0">Duration div : </span>
													<v-col cols="2">
														<v-select
															v-model="durDiv.select"
															:items="durDiv.items"															
                              item-text="name"                              
															item-value="cd"
															return-object
															single-line
															outlined
															dense
														></v-select>
													</v-col>
													<v-col cols="2">
                          <DxDateBox :value="startDate" height="30px"
                                  display-format="yyyy-MM-dd" :acceptCustomValue="false"
                                  @value-changed="e => { reqDtFrom = e.value && getStrFormat(e.value) }" />
                          </v-col>
                          <span class="pa-1 pt-2 subTitle"> ~ </span>
                          <v-col cols="2">
                              <DxDateBox :value="endDate" height="30px"
                                  display-format="yyyy-MM-dd" :acceptCustomValue="false"
                                  @value-changed="e => { reqDtFrom = e.value && getEndFormat(e.value) }" />
                          </v-col>																																
												</v-row>
											</v-col>
										</v-row>
									</template>
								</i-card-top>
							</v-col>
						</v-row>              
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">                
                  <DxDataGrid id="epms91C0" 
                    class="listBox" 
                    :ref="epms91C0Ref"
                    :data-source="gridMainList" :remote-operations="false"
                    :hover-state-enabled="true" :allow-column-resizing="true"
                    :allow-column-reordering="true" :row-alternation-enabled="true"
                    :show-borders="true" :width="grid.width" :show-row-lines="true" key-expr="id"
                    :focused-row-enabled="true" :column-hiding-enabled="false"
                    :selection="{ mode: 'none' }" :sorting="{ mode: 'none' }"                  
                    @cellPrepared="cellPrepared">
                    
                    <DxColumn data-field="rnum" caption="No" width="5%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn caption="Ship No" width="15%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="shipNo" caption="POR No" width="15%" data-type="string" alignment="center" :allow-editing="false" cell-template = "porNoTemplate"/>
                    </DxColumn>

                    <template #porNoTemplate="{ data }">
                        <div>
                            <div v-if="data.rowIndex % 2 != 0">
                                <v-btn small elevation="0" color="transparent" class="px-0 py-0 grd-btn" @click.stop="drawingPage($event)">
                                    {{ data.value.slice(0, 8) }}
                                </v-btn>-{{ data.value.slice(9, 11) }}
                            </div>
                            <div v-else>
                                {{ data.value }}
                            </div>                                                                                               
                        </div>                        
                    </template>  

                    <DxColumn data-field="porRevNo"  caption="Por Rev" width="7%" data-type="string" alignment="center" :allow-editing="false" header-cell-template = 'porRev'/>   
                    <template #porRev>   
                        <div> Por <br/> Rev </div>
                    </template>template>
                    <DxColumn caption="POR Date" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="porDt" caption="Material Need Date" width="10%" data-type="string" alignment="center" :allow-editing="false" header-cell-template = 'matlNeedDte'/>
                    </DxColumn>
                    <template #matlNeedDte>   
                        <div>Material<br/>Need Date</div>
                    </template>template>
                    <DxColumn caption="Block" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="block" caption="Stage" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>  
                    <DxColumn  data-field="partSpec"  caption="Part Specification" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="partNo" caption="Part No" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="partQty" caption="Qty" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="unit" caption="Unit" width="10%" data-type="string" alignment="center" :allow-editing="false" />                      
                      <DxColumn data-field="partUnitWgt" caption="Weight" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>                                       
                    <DxColumn caption= "Class" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="insp" caption="Insp." width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption= "Pro In" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="pipeInProc" caption="Pro Out" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption= "Paint In" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="pipeInPaint" caption="Paint Out" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption= "PO Date" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="poAmtUsd" caption="PO Amount" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn data-field="delyNo" caption= "Delivery Note" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="delyDte" caption="Dely. Date" width="10%" data-type="string" alignment="center" :allow-editing="false" />                      
                    </DxColumn>  
                    <DxColumn  caption="Dely. Qty" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                       <DxColumn data-field="delyQty" caption="Dely Amout" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn  caption= "WH. Date" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="whDte" caption="Warehouse Location" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>  
                    <DxColumn  caption= "WH. Qty" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="whQty" caption="Warehouse Location" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>


                    <DxColumn caption= "Issue Date" width="10%" data-type="string" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="issueQty" caption="Issue. Qty" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="issueAmtUsd" caption="Issue. Amount" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                  <DxPaging :enabled="true" :page-size="20" />
                  </DxDataGrid>
                </v-col>
              </v-row>
            </v-layout>
          </template> 
        </i-card-vertical>
      </v-col>
    </v-row>
    <drawingPagePop v-if="showPop" :showPop.sync="showPop" :gbn="'POR'" :paramNo="dwgPorNo" />
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn , DxButton , DxExport } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import { getDateFormat, getCurrentDate, getFirstDate , getFirstDay, getNumComma} from '@/utils/common.js'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { getShipNoList1, epms9000_por_no } from '@/api/view/hip/common/common.js'
import { getEpms91C0, getEpms91C0Xls } from '@/api/view/hip/91/epms91C0.js'
import drawingPagePop from '@/views/hip/common/drawingPagePop'

export default {
  name: 'epms91C0',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxDateBox,
    DxColumn,
    DxEditing,
    drawingPagePop
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      epms91C0Ref: 'epms91C0Ref',
      gridMainList: [],

      selectShipNo: '',
      shipNoList: [],
      selectPorNo: 'All',
      porList: [],

      showPop: false,
      dwgPorNo: '',

      whDiv: {
        select: { name: 'All', cd: 'A' },
        items: [
          { name: 'All', cd: 'A' }
        ]
      },

      durDiv: {
        select: { name: 'By Need Date', cd: '0' },
        items: [
          { name: 'By Need Date', cd: '0' }
        ]
      },

      stage: {
        select: { name: 'All', cd: '%' },
        items: [
          { name: 'All', cd: '%' }
        ]
      },

      startDate: '',
      endDate: '',

      stDte: '',
      edDte: ''
    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epms91C0Ref)
    },
  },
  methods: {

    getStrFormat(date) {
      this.stDte = getDateFormat(date)
      return getDateFormat(date)
    },
    getEndFormat(date) {
      this.edDte = getDateFormat(date)
      return getDateFormat(date)
    },

    async getShipNoList() {
      let params = {
        makerCd: this.$store.state.user.makerCd
      }

      await getShipNoList1(params).then(res => {
        res.list.forEach(e => {
          this.shipNoList.push(e.shipNo)
        });
      })
    },

    async getPorList() {
      let params = {
        incNotPo: 'P',
        makerCd: this.$store.state.user.makerCd,
        shipNo: this.selectShipNo
      }

      await epms9000_por_no(params).then(res => {
        this.porList.push('All')
        res.list.forEach(e => {
          this.porList.push(e.porNo)
        });
      })
    },

    async getInitList() {
      try {
        this.openLoading('searching')
        let params = {
          code: '',
          codegr: '',
          prtCode: 'DIV_9113',
          userFlag: 'Y',
        }
        let params2 = {
          code: '',
          codegr: '',
          prtCode: 'WH_DIV',
          userFlag: 'Y'
        }

        let params3 = {
          code: '',
          codegr: '',
          prtCode: 'STG_9113',
          userFlag: 'Y'
        }

        await getCmChildCode(params).then(res => {
          res.list.forEach(e => {
            if (e.code !== '0') {
              this.durDiv.items.push({ name: e.codeName, cd: e.code })
            }
          });
        })

        getCmChildCode(params2).then(res => {
          res.list.forEach(e => {
            this.whDiv.items.push({ name: e.codeName, cd: e.code })
          });
        })


        getCmChildCode(params3).then(res => {
          res.list.forEach(e => {
            this.stage.items.push({ name: e.codeName, cd: e.code })
          });
        })

      } finally {
        this.endLoading()
      }
    },
    changeShipNo(e) {

      this.selectPorNo = ''
      this.porList = []

      this.getPorList()

    },

    btnRetrieve() {
      if (this.shipNo === null) {
        this.vToastify(this.$t('Please select Ship No'), 'warn')
        return
      }
      if (this.porNo === null) {
        this.porNo = ''
      }

      this.doSearchMain()
    },
    async doSearchMain() {
      this.openLoading('searching')
      let params = {
        makerCd: this.$store.state.user.makerCd,
        shipNo: this.selectShipNo,
        porNo: this.selectPorNo === 'All' ? '' : this.selectPorNo,
        stg: this.stage.select.cd,
        startDate: this.stDte,
        endDate: this.edDte,
        whYn: this.whDiv.select.cd,
        durDiv: this.durDiv.select.cd
      }
      console.log(params)
      await getEpms91C0(params).then(res => {
        let list = []
        let cnt = 1;
        res.list.forEach(e => {

          list.push(
            {
              id: cnt++, rnum: e.rnum, shipNo: e.shipNo, porRevNo: e.porRevNo, porDt: e.porDt, block: e.block,
              partNo: e.partSpec, partQty: e.partSpec, unit: e.partSpec, partUnitWgt: e.partSpec,
              insp: e.cls, pipeInProc: e.pipeInProc, pipeInPaint: e.pipeInPaint,
              poAmtUsd: e.poDte, delyDte: e.delyNo, delyQty: e.delyQty, whDte: e.whDte, whQty: e.whQty,
              issueQty: e.issueDte, issueAmtUsd: e.issueDte

            },
            {
              id: cnt++, rnum: e.rnum, shipNo: e.porNo + '-' + e.porSeq, porRevNo: e.porRevNo, porDt: e.psdDt, block: e.stageNm,
              partNo: e.partNo, partQty: e.partQty, unit: e.matlUnit, partUnitWgt: e.partUnitWgt,
              insp: e.insp, pipeInProc: e.pipeOutProc, pipeInPaint: e.pipeOutPaint,
              poAmtUsd: e.poAmtUsd, delyDte: e.delyDte, delyQty: e.delyAmt, whDte: e.locNo, whQty: e.locNo, 
              issueQty: e.issueQty, issueAmtUsd: e.issueAmtUsd
            }
          )
        });
        this.gridMainList = list

      }).finally(() => {
        this.endLoading()
      })

    },

    btnExcel() {
      this.openLoading('Saving Excel!')
      let params = {
         makerCd: this.$store.state.user.makerCd,
        shipNo: this.selectShipNo,
        porNo: this.selectPorNo === 'All' ? '' : this.selectPorNo,
        stg: this.stage.select.cd,
        startDate: this.stDte,
        endDate: this.edDte,
        whYn: this.whDiv.select.cd,
        durDiv: this.durDiv.select.cd
      }

      getEpms91C0Xls(params).finally(() => {
        this.endLoading();
      })

    },

    drawingPage(e) {

      let porNo = e.srcElement.innerText

      this.dwgPorNo = porNo.slice(0, 8)

      console.log(this.dwgPorNo)

      this.showPop = true
    },

    cellPrepared(e) {
      if (e.rowType === 'data') {
         if (e.column.caption === 'No' || e.column.caption === 'Por Rev') {
          if (e.value == e.component.cellValue(e.rowIndex + 1, e.column.dataField) && e.values[0] == e.component.cellValue(e.rowIndex + 1, 'rnum')) {
            e.cellElement.setAttribute('rowspan', 2)
          } else {
            e.cellElement.style.display = 'none'
          }
        }

        console.log(e)
        if (Number(e.rowIndex) % 2 === 0) {   // row chan         
          if (e.column.name === 'partNo') {
            e.cellElement.setAttribute('colspan', 4)
          } else if (e.column.name === 'partQty') {
            e.cellElement.style.display = 'none'
          } else if (e.column.name === 'unit') {
            e.cellElement.style.display = 'none'
          } else if (e.column.name === 'partUnitWgt') {
            e.cellElement.style.display = 'none'
          }                    

          if (e.column.name === 'issueQty') {
            e.cellElement.setAttribute('colspan', 2)          
          } else if (e.column.name === 'issueAmt') {
            e.cellElement.style.display = 'none'            
          }
          // set color

          if (e.column.name === 'whQty') {
            e.cellElement.style.backgroundColor = "#C6D3A0"
          }

          if (e.column.name === 'delyQty') {
            e.cellElement.style.backgroundColor = "#C6F3F0"
          }

        } else { //row le

          if (e.column.name === 'partQty') {
            e.cellElement.style.backgroundColor = "#B6D3F0"
          }

          if (e.column.name === 'delyQty') {
            e.cellElement.style.backgroundColor = "#C6D3A0"
          }

          if (e.column.name === 'whDte') {
            e.cellElement.setAttribute('colspan', 2)
          } else if (e.column.name === 'whQty') {
            e.cellElement.style.display = 'none'
          }           

           if (e.column.name === 'issueQty') {          
            e.cellElement.style.backgroundColor = "#C6D3A0"
          } else if (e.column.name === 'issueAmtUsd') {            
            e.cellElement.style.backgroundColor = "#C6D3A0"
          }

        }

      } else if (e.rowType === 'header') {

        if (e.column.caption === 'Warehouse Location' && e.columnIndex === 13) {         
            e.cellElement.setAttribute('colspan', 2)
          } else if (e.column.caption === 'Warehouse Location' && e.columnIndex === 14) {
            e.cellElement.style.display = 'none'
          }
        
      }
    }
  },
   mounted() {
    var date = new Date();
    this.startDate = new Date(date.getFullYear(), 0, 1)
    this.endDate = new Date(date.getFullYear(), date.getMonth() + 2, 0);


    this.getShipNoList()
    this.getInitList()
    this.gridMainInstance.option('defaultPaging', false)
  }
}

</script>
<style lang="scss" scoped>
  .subTitle {
    font-weight: bold;
    color: black;
  }
  .vat {
    color: blue;
  }
  .receiptBtn {
    font-weight: bold;
  }
  .receiptBtn:hover {
    color: #4980BC;
  }
  .v-btn {
    text-transform: unset !important;
    // height: 16px !important;
  }
</style>